"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var InputComponents_exports = {};
__export(InputComponents_exports, {
  ButtonField: () => ButtonField,
  ColorField: () => ColorField,
  DateField: () => DateField,
  DatetimeLocalField: () => DatetimeLocalField,
  EmailField: () => EmailField,
  FileField: () => FileField,
  HiddenField: () => HiddenField,
  ImageField: () => ImageField,
  InputField: () => InputField,
  MonthField: () => MonthField,
  NumberField: () => NumberField,
  PasswordField: () => PasswordField,
  RadioField: () => RadioField,
  RangeField: () => RangeField,
  ResetField: () => ResetField,
  SearchField: () => SearchField,
  SubmitField: () => SubmitField,
  TelField: () => TelField,
  TextField: () => TextField,
  TimeField: () => TimeField,
  UrlField: () => UrlField,
  WeekField: () => WeekField
});
module.exports = __toCommonJS(InputComponents_exports);
var import_react = __toESM(require("react"));
var import_pascalcase = __toESM(require("pascalcase"));
var import_useErrorStyles = require("./useErrorStyles");
var import_useRegister = require("./useRegister");
const INPUT_TYPES = [
  "button",
  "color",
  "date",
  "datetime-local",
  "email",
  "file",
  "hidden",
  "image",
  "month",
  "number",
  "password",
  "radio",
  "range",
  "reset",
  "search",
  "submit",
  "tel",
  "text",
  "time",
  "url",
  "week"
];
const InputField = (0, import_react.forwardRef)(
  ({
    name,
    id,
    emptyAs,
    // for useErrorStyles
    errorClassName,
    errorStyle,
    className,
    style,
    // for useRegister
    validation,
    onBlur,
    onChange,
    type,
    ...rest
  }, ref) => {
    const styles = (0, import_useErrorStyles.useErrorStyles)({
      name,
      errorClassName,
      errorStyle,
      className,
      style
    });
    const useRegisterReturn = (0, import_useRegister.useRegister)(
      {
        name,
        validation,
        onBlur,
        onChange,
        type
      },
      ref,
      emptyAs
    );
    return /* @__PURE__ */ import_react.default.createElement(
      "input",
      {
        id: id || name,
        ...rest,
        type,
        ...styles,
        ...useRegisterReturn
      }
    );
  }
);
const InputComponents = {};
INPUT_TYPES.forEach((type) => {
  InputComponents[`${(0, import_pascalcase.default)(type)}Field`] = (0, import_react.forwardRef)((props, ref) => /* @__PURE__ */ import_react.default.createElement(InputField, { ref, type, ...props }));
});
const {
  ButtonField,
  ColorField,
  DateField,
  DatetimeLocalField,
  EmailField,
  FileField,
  HiddenField,
  ImageField,
  MonthField,
  NumberField,
  PasswordField,
  RadioField,
  RangeField,
  ResetField,
  SearchField,
  SubmitField,
  TelField,
  TextField,
  TimeField,
  UrlField,
  WeekField
} = InputComponents;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ButtonField,
  ColorField,
  DateField,
  DatetimeLocalField,
  EmailField,
  FileField,
  HiddenField,
  ImageField,
  InputField,
  MonthField,
  NumberField,
  PasswordField,
  RadioField,
  RangeField,
  ResetField,
  SearchField,
  SubmitField,
  TelField,
  TextField,
  TimeField,
  UrlField,
  WeekField
});
